import {
  FiPhone,
  FiMessageSquare,
  FiMapPin,
  FiClock,
  FiShield,
  FiCheckCircle
} from "react-icons/fi";

import { motion } from "framer-motion";
import "./Contact.css";


function Contact() {


return (

<section className="contact" id="contact">


<div className="container contact-wrapper">


<motion.div

className="contact-content"

initial={{
opacity:0,
x:-50
}}

whileInView={{
opacity:1,
x:0
}}

viewport={{
once:true
}}

>


<div className="live-status">

<span></span>

Locksmiths Available 24/7

</div>



<span className="contact-tag">
EMERGENCY ASSISTANCE
</span>



<h2>
Locked Out?
<br/>
Don't Wait. Call Now.
</h2>



<p>

Lost your keys, locked yourself out,
or dealing with a broken lock?
Our professional Cape Town locksmith team
is ready to help anytime, day or night.

</p>




<div className="contact-buttons">


<a
href="tel:+27604971899"
className="contact-call"
>

<FiPhone/>

Call Locksmith Now

</a>



<a

href="https://wa.me/27604971899"

target="_blank"

rel="noreferrer"

className="contact-whatsapp"

>

<FiMessageSquare/>

WhatsApp Us

</a>


</div>




<div className="phone-display">

<FiPhone/>

<div>

<span>
Emergency Number
</span>

<h3>
+27604971899
</h3>

</div>


</div>



</motion.div>







<motion.div

className="contact-cards"

initial={{
opacity:0,
x:50
}}

whileInView={{
opacity:1,
x:0
}}

viewport={{
once:true
}}

>



<div className="contact-card">

<div className="icon">

<FiClock/>

</div>


<div>

<h3>
24/7 Emergency Service
</h3>

<p>
Available nights, weekends,
and public holidays.
</p>

</div>


</div>





<div className="contact-card">

<div className="icon">

<FiMapPin/>

</div>


<div>

<h3>
Cape Town Coverage
</h3>

<p>
Serving homes, vehicles,
and businesses across the city.
</p>

</div>


</div>






<div className="contact-card">

<div className="icon">

<FiShield/>

</div>


<div>

<h3>
Trusted Professionals
</h3>

<p>
Reliable workmanship with
security-focused solutions.
</p>

</div>


</div>




<div className="trust-line">

<FiCheckCircle/>

Fast Response • Professional Service • Peace Of Mind

</div>



</motion.div>



</div>


</section>

)

}


export default Contact;